import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../hooks/hooks";
import moment from "moment";
import _ from "lodash";
import storePersist from "../../../../../redux/storePersist";
import { addPayment } from "../../../../../redux/addPayment/action";
import { orders } from "../../../../../redux/orders/action";
import { shippingTypes } from "../../../../../redux/shippingTypes/action";
import { selectShippingTypesListItems } from "../../../../../redux/shippingTypes/selector";
import { categories } from "../../../../../redux/categories/action";
import { selectProductsListItems } from "../../../../../redux/products/selector";
import queryString from "query-string";
import CryptoJS from 'crypto-js';
import VehicleCard from "./vehicle-card";
import { toast } from "react-toastify";
import Popup from "../../../../../common/components/popup";
import ModalQuotesDetailsComponent from "./modal-quotes-detail";
import { selectCargoQuotesCreatedItem } from "../../../../../redux/cargo-quotes/selector";
import { selectVehiclesListItems } from "../../../../../redux/vehicles/selector";
import { cargoQuotes } from "../../../../../redux/cargo-quotes/action";
import { selectCargoLeadsCreatedItem } from "../../../../../redux/cargo-lead/selector";
import { vehicles } from "../../../../../redux/vehicles/action";
import { cargoLeads } from "../../../../../redux/cargo-lead/action";
import { selectOrdersCreatedItem } from "../../../../../redux/orders/selector";
import { selectPaymentMethodsQueryItems } from "../../../../../redux/payment-methods/selector";
import { selectOrganizationUnitsListItems } from "../../../../../redux/organizationUnits/selector";
import { useNavigate } from "react-router-dom";
import { selectProductTypesListItems } from "../../../../../redux/product-types/selector";
import { productTypes } from "../../../../../redux/product-types/action";
import ModalEwayComponent from "./e-way-modal";
import { selectLogisticsConfigurationsQueryItem } from "../../../../../redux/logistics-Configurations/selector";
import { selectaddressBooksListItems } from "../../../../../redux/address-books/selector";
import { addressBooks } from "../../../../../redux/address-books/action";
import AddressBookComponent from "./address-book.component";
import { vehicleCategories } from "../../../../../redux/vehicle-categories/action";
import { selectVehicleCategoriesListItems } from "../../../../../redux/vehicle-categories/selector";
import * as R from "ramda"

declare let Razorpay: any;
let currentChange: any = {};

// export const setDisplayLoadCapacity = (tags: any) => R.map((tag: any) => R.assoc(
//     'displayLoadCapacity',
//     `Min:${tag.MinimumLoadingCapacity}-Max:${tag.MaximumLoadingCapacity} kg`,
//     tag
// ))(tags)


const AdvanceCargoBookingsWeb = () => {

    const navigate = useNavigate();
    const dispatch = useAppDispatch()
    const userInfo = storePersist?.get("userProfile")?.current?.items;
    const userProfileData = storePersist?.get("userProfile")?.current?.items[0]?.Message;
    var tenantId = storePersist.get('guestTokenMetadata')?.current?.result?.TokenMetadata?.TenantId
    var storeId = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization?.StoreId;
    const MODE = 'secure';

    //UseSelector Declaration
    const ProductLists = useSelector(selectProductsListItems)
    const leadCreateData = useSelector(selectCargoLeadsCreatedItem)
    const shippingTypesDetails = useSelector(selectShippingTypesListItems)
    const quoteDetails = useSelector(selectCargoQuotesCreatedItem)
    const organizationUnitLists = useSelector(selectOrganizationUnitsListItems)
    const vehicleData = useSelector(selectVehiclesListItems)
    const vehicleCategoryData = useSelector(selectVehicleCategoriesListItems)
    const paymentSettings = useSelector(selectLogisticsConfigurationsQueryItem)
    const orderDetails = useSelector(selectOrdersCreatedItem)
    const paymentMethodQuery = useSelector(selectPaymentMethodsQueryItems)
    const productTypesListItems = useSelector(selectProductTypesListItems)
    const addressbookItems = useSelector(selectaddressBooksListItems)
    const productTypeCargo = productTypesListItems?.result?.items.filter(
        (data: any) => data.IsCargoOrder === true
    )
    const isOpenComponent = quoteDetails?.result?.Records[0]?.message?.order?.LinkedItems[0]?.value?.value >= 50000;


    // useState Declaration
    const [isOpenPayment, setIsOpenPayment] = useState<boolean>(false)
    const [isQuote, setIsQuote] = useState<boolean>(false)
    const [isLead, setIsLead] = useState<boolean>(false)
    const [selected, setSelected] = useState<any>();
    const [paymentSelectedInput, setPaymentSelectedInput] = useState<any>(undefined);
    const [paymentMode, setPaymentMode] = useState<any>(undefined);
    const [cargoValues, setCargoValues] = useState<any>([])
    const [generateIds, setGenerateIds] = useState<any>([]);
    const [razorpaySettings, setRazorpaySettings] = useState<any>([])
    const [isPaymentAdded, setIsPaymentAdded] = useState<any>(false);
    const [paymentGateway, setPaymentGateway] = useState<any>([]);
    const [orderItem, setOrderItem] = useState<any>(undefined);
    const [isOrderPlaced, setIsOrderPlaced] = useState<any>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [
        mediaFiles,
        setMediaFiles
    ] = useState<any>()
    const [selectedVehicleItem, setSelectedVehicleItem] = useState<any>({});
    const [selectedEstimateItem, setSelectedEstimateItem] = useState<any>({
        Name: userInfo[0]?.Message?.FirstName || '',
        PhoneNumber: userInfo[0]?.Message?.PhoneNumber || '',
        Pickup: '',
        Drop: '',
    });
    const [addressBook, setAddressBook] = useState<any>([]);
    const [selectedFromAddressBookId, setSelectedFromAddressBookId] = useState<any>(null);
    const [selectedFromAddressBook, setSelectedFromAddressBook] = useState(null);
    const [selectedToAddressBookId, setSelectedToAddressBookId] = useState<any>(null);
    const [selectedToAddressBook, setSelectedToAddressBook] = useState(null);
    const [enablePlaceOrder, setEnablePlaceOrder] = useState(false);
    const [enableConfirm, setEnableConfirm] = useState<boolean>(false)
    var userProfile = storePersist?.get("userProfile")?.current;
    const addressbookId = userProfile.items[0]?.Message.AddressBookId;


    // Address Book 
    useEffect(() => {
        dispatch(addressBooks.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-features/addressbooks/query`,
            entity: 'addressBooks',
            jsonData: {
                "Records": [
                    {
                        "Id": addressbookId
                    }
                ]
            }
        }));
    }, [dispatch]);

    useEffect(() => {
        if (addressbookItems?.result?.items[0]?.Addresses) {
            setAddressBook(addressbookItems?.result?.items[0]?.Addresses);
            setSelectedFromAddressBook(addressbookItems?.result?.items[0]?.Addresses[0] || "no data")
            setSelectedFromAddressBookId(addressbookItems?.result?.items[0]?.Addresses[0].Id)
            setSelectedToAddressBook(addressbookItems?.result?.items[0]?.Addresses[1] || "no data")
            setSelectedToAddressBookId(addressbookItems?.result?.items[0]?.Addresses[1]?.Id)
        }
    }, [addressbookItems]);

    // Generate Unique Id
    const generateUniqueId = () => {
        const randomPart = Math.random().toString(36).substr(2, 9); // Random part
        const timestampPart = Date.now().toString(36); // Timestamp part
        return `${randomPart}-${timestampPart}`;
    };

    const generateIdValue = () => {
        const newItem = {
            transaction_id: generateUniqueId(),
            message_id: generateUniqueId(),
            fulfillment_id: generateUniqueId(),
            item_id: generateUniqueId(),
            order_id: generateUniqueId(),
        };
        setGenerateIds(newItem);
    };


    //cargo basic details functions
    const handleChange: any = (event: any, field: string) => {
        setCargoValues({ ...cargoValues, [field]: event })
        setSelectedEstimateItem({ ...selectedEstimateItem, [field]: event });
    }


    const handleEstimate = async (itemData: any) => {
        const vehicleData: any = {
            vehicleCategoryId: itemData?.LogisticsVehicleCategoryId,
            vehicleId: itemData?.Id,
            vehicleName: itemData?.VehicleName,
            VehicleBodyTypeId: itemData?.VehicleBodyTypeId,
            LoadingCapacity: itemData?.LoadingCapacity,
            TripVehicleBasePrice: itemData?.TripVehicleBasePrice,
            VehicleWeight: itemData?.VehicleWeight,
            RegistrationNumber: itemData?.RegistrationNumber,
        }
        setSelectedVehicleItem(vehicleData)
        if (!selectedEstimateItem?.CategoryId || !selectedEstimateItem?.ProductValue || !itemData?.Id) {
            toast.error("Please fill in the Product Type and Product Value details, and select the Vehicle Type.");
            return; // Stop further execution if validation fails
        } else {
            await handleLeadSubmit()

        }
    }



    // Step 1: Submit Lead
    const handleLeadSubmit = async () => {
        await generateIdValue()
        // Validation for required fields
        if (
            !selectedEstimateItem?.CategoryId ||
            !selectedEstimateItem?.date ||
            !selectedEstimateItem?.ProductValue
        ) {
            toast.error("All fields are required. Please fill in all the details.");
            return;
        }
        if (!selectedFromAddressBook?.Latitude || !selectedFromAddressBook?.Longitude) {
            toast.error("Please enter a valid Pickup Address");
            return;
        }
        if (!selectedToAddressBook?.Latitude || !selectedToAddressBook?.Longitude) {
            toast.error("Please enter a valid Drop Address");
            return;
        }
        // Validate phone number length
        if (selectedFromAddressBook?.PhoneNumber?.length < 10) {
            toast.error("Please enter a valid phone number with at least 10 digits in the Pickup Address field.");
            return;
        }
        if (selectedToAddressBook?.PhoneNumber?.length < 10) {
            toast.error("Please enter a valid phone number with at least 10 digits in the Drop Address field.");
            return;
        }

        try {

            if (selectedFromAddressBook?.Id !== selectedToAddressBook?.Id) {
                await setIsLoading(true)
                await dispatch(cargoLeads.resetAction({ actionType: 'create' }))
                await dispatch(
                    cargoLeads.create({
                        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/leads`,
                        entity: 'leadCreate', options: { notifyOnSuccess: false, notifyOnFailed: true },
                        jsonData: {
                            Records: [
                                {
                                    Context: {
                                        transaction_id: generateIds?.transaction_id,
                                        message_id: generateIds?.message_id,
                                    },
                                    Message: {
                                        LeadInfo: {
                                            Name: userInfo[0]?.Message?.FirstName || '',
                                            Email: userInfo[0]?.Message?.Email || null,
                                            PhoneNumber: userInfo[0]?.Message?.PhoneNumber || '',
                                            date: selectedEstimateItem?.date,
                                            Description: '',
                                            IsExistingUser: true,
                                            LeadPayload: {
                                                weight: {
                                                    unit: '',
                                                    value: 0,
                                                },
                                                dimensions: {
                                                    length: {
                                                        unit: '',
                                                        value: 0,
                                                    },
                                                    breadth: {
                                                        unit: '',
                                                        value: 0,
                                                    },
                                                    height: {
                                                        unit: '',
                                                        value: 0,
                                                    },
                                                },
                                                category: '',
                                                value: {
                                                    currency: 'INR',
                                                    value: 0,
                                                },
                                                dangerous_goods: false,
                                            },
                                            start: {
                                                location: {
                                                    gps: `${selectedFromAddressBook?.Latitude},${selectedFromAddressBook?.Longitude}`,
                                                    address: {
                                                        name: `${selectedFromAddressBook?.FirstName} ${selectedFromAddressBook?.LastName}`,
                                                        building: selectedFromAddressBook?.Address1,
                                                        locality: selectedFromAddressBook?.Address2,
                                                        city: selectedFromAddressBook?.City,
                                                        state: selectedFromAddressBook?.StateProvince?.Name,
                                                        country: selectedFromAddressBook?.Country?.Name,
                                                        area_code: selectedFromAddressBook?.ZipPostalCode,
                                                    },
                                                },
                                                contact: {
                                                    phone: selectedFromAddressBook?.PhoneNumber,
                                                    email: selectedFromAddressBook?.Email,
                                                },
                                            },
                                            end: {
                                                location: {
                                                    gps: `${selectedToAddressBook?.Latitude},${selectedToAddressBook?.Longitude}`,
                                                    address: {
                                                        name: `${selectedToAddressBook?.FirstName} ${selectedToAddressBook?.LastName}`,
                                                        building: selectedToAddressBook?.Address1,
                                                        locality: selectedToAddressBook?.Address2,
                                                        city: selectedToAddressBook?.City,
                                                        state: selectedToAddressBook?.StateProvince?.Name,
                                                        country: selectedToAddressBook?.Country?.Name,
                                                        area_code: selectedToAddressBook?.ZipPostalCode,
                                                    },
                                                },
                                                contact: {
                                                    phone: selectedToAddressBook?.PhoneNumber,
                                                    email: selectedToAddressBook?.Email,
                                                },
                                            },
                                        },
                                    },
                                },
                            ],
                        },
                    })
                );
                await setIsLead(true)
                await setIsLoading(false)
            }

            else {
                toast.error("The Pickup and Drop addresses must be different.")

            }

        } catch (error) {
            toast.error("An error occurred while submitting the form. Please try again.");

        }
    };

    useEffect(() => {
        if (isLead && leadCreateData?.isSuccess) {
            handleSavePackageItem()
            setIsLead(false)
        }
    }, [isLead])

    //Step 2: Submit Quote
    const handleSavePackageItem = async () => {
        await generateIdValue()
        await setIsLoading(true)
        await dispatch(cargoQuotes.resetAction({ actionType: 'create' }))
        // let shippingType = _.find(shippingTypesDetails.result.items, ['ShippingTypeName', 'Immediate Delivery']);
        let shippingType = shippingTypesDetails.result.items[0];
        const valueData = {
            order: {
                IsCargoOrder: true,
                provider: {
                    id: 0,
                    locations: []
                },
                items:
                    [{
                        id: String(shippingType?.Id) || 0,
                        fulfillment_id: generateIds?.fulfillment_id,
                        category_id: shippingType?.ShippingTypeName || "",
                        descriptor: {
                            code: "P2P" // shipmentType (library call)
                        },
                        time: {
                            label: "",
                            duration: "",
                            timestamp: selectedEstimateItem?.date || ""
                        }
                    },
                    ],
                billing: {},
                payment: {},
                LinkedItems: [{
                    CategoryId: selectedEstimateItem?.CategoryId,
                    LogisticsProductId: 0,
                    LogisticsVariantId: 0,
                    quantity: {
                        count: 0,
                        measure: {
                            unit: "kg",
                            value: 0
                        }
                    },
                    weight: {
                        unit: "mm",
                        value: 0
                    },
                    dimensions: {
                        length: {
                            unit: "mm",
                            value: 0
                        },
                        breadth: {
                            unit: "mm",
                            value: 0
                        },
                        height: {
                            unit: "mm",
                            value: 0
                        }
                    },
                    value: {
                        currency: "INR",
                        value: selectedEstimateItem?.ProductValue
                    },
                    dangerous_goods: false
                }],
                fulfillments: [
                    {
                        id: generateIds?.fulfillment_id,
                        type: 'Delivery_and_Self_Pickup',
                        start: {
                            location: {
                                gps: `${selectedFromAddressBook?.Latitude},${selectedFromAddressBook?.Longitude}`,
                                address: {
                                    name: `${selectedFromAddressBook?.FirstName} ${selectedFromAddressBook?.LastName}`,
                                    building: selectedFromAddressBook?.Address1,
                                    locality: selectedFromAddressBook?.Address2,
                                    city: selectedFromAddressBook?.City,
                                    state: selectedFromAddressBook?.StateProvince?.Name,
                                    country: selectedFromAddressBook?.Country?.Name,
                                    area_code: selectedFromAddressBook?.ZipPostalCode || ''
                                }
                            },
                            contact: {
                                phone: selectedFromAddressBook?.PhoneNumber,
                                email: selectedFromAddressBook?.Email,
                            }
                        },
                        end: {
                            location: {
                                gps: `${selectedToAddressBook?.Latitude},${selectedToAddressBook?.Longitude}`,
                                address: {
                                    name: `${selectedToAddressBook?.FirstName} ${selectedToAddressBook?.LastName}`,
                                    building: selectedToAddressBook?.Address1,
                                    locality: selectedToAddressBook?.Address2,
                                    city: selectedToAddressBook?.City,
                                    state: selectedToAddressBook?.StateProvince?.Name || 'TamilNadu',
                                    country: selectedToAddressBook?.Country?.Name,
                                    area_code: selectedToAddressBook?.ZipPostalCode || ''
                                }
                            },
                            contact: {
                                phone: selectedToAddressBook?.PhoneNumber,
                                email: selectedToAddressBook?.Email,
                            }
                        },
                        vehicle: {
                            vehicleCategoryId: selectedVehicleItem?.vehicleCategoryId,
                            vehicleId: selectedVehicleItem?.vehicleId,
                            vehicleName: selectedVehicleItem?.vehicleName,
                            weight: selectedVehicleItem?.VehicleWeight,
                            loading_capacity: selectedVehicleItem?.LoadingCapacity,
                            registration: selectedVehicleItem?.RegistrationNumber,
                            TripVehicleBasePrice: selectedVehicleItem?.TripVehicleBasePrice,
                            VehicleBodyTypeId: selectedVehicleItem?.VehicleBodyTypeId
                        }
                    }
                ]
            }
        }

        await dispatch(cargoQuotes.create(
            {
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/logistics-quotes`,
                entity: 'quotes', options: { notifyOnSuccess: false, notifyOnFailed: true },
                jsonData: {
                    Records: [{
                        context: {
                            transaction_id: leadCreateData?.result?.Records[0]?.Context?.transaction_id,
                            message_id: generateIds?.item_id,
                        },
                        message: valueData,
                    }]
                }
            }))
        await setIsQuote(true)
        await setIsLoading(false)
        setEnableConfirm(true)
    }

    useEffect(() => {
        if (isQuote && quoteDetails?.isSuccess) {
            // Open estimate modal
            setOrderItem({
                id: 0
            })
            setIsQuote(false)
        } else {
            setIsQuote(false)
        }

    }, [isQuote])

    //NewEstimatePopup
    const NewEstimatePopup = ({ handleOrderBooking }: any) => {

        const handleFormPayment = () => {
            handleOrderBooking()
        }
        const handlePaymentInput = (e: any, item: any) => {
            setSelected(item.value)
            setPaymentMode(item)
            setPaymentSelectedInput(e.target.value)
        }
        const closeModal = () => {
            generateIdValue()
            setOrderItem(undefined)
        }

        const handleBookLater = () => {
            generateIdValue()
            setOrderItem(undefined)
            generateIdValue()
            setEnableConfirm(false)
            setIsOpenPayment(false)

            navigate('/customer/bookings/cargo')
        }



        const handleFileURlSubmit = async (urlData) => {
            await setIsOpenPayment(true)
            await setMediaFiles(
                [{
                    Id: 0,
                    FileTypeId: urlData?.FileType === 'image' ? 10 : 20,
                    OwnerId: 0,
                    OwnerType: "shipping",
                    OwnerTypeId: 1007,
                    FileMappingURL: urlData?.DocumentPath
                }]
            )

        }

        return (
            <>
                <Popup onClose={closeModal}>


                    {enableConfirm && isOpenComponent && !isOpenPayment ? <ModalEwayComponent
                        handleFileURlSubmit={handleFileURlSubmit}
                        selectedVehicleItem={selectedVehicleItem}
                        quoteDetails={quoteDetails} />
                        :
                        <ModalQuotesDetailsComponent
                            handleBookLater={handleBookLater}
                            selectedVehicleItem={selectedVehicleItem}
                            quoteDetails={quoteDetails}
                            enablePlaceOrder={enablePlaceOrder}
                            handlePayment={handleFormPayment}
                            isLoading={isLoading}
                            paymentSettings={paymentSettings}
                            paymentSelectedInput={paymentSelectedInput}
                            handlePaymentInput={handlePaymentInput} />}
                </Popup>
            </>
        )
    }

    //Step 3: Add Payment
    const handleOrderBooking = async () => {
        await setIsLoading(true)
        await dispatch(addPayment.update({
            url: `https://dom.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/dom/check-outs/add-payment`,
            entity: 'addPayment', options: { notifyOnSuccess: false, notifyOnFailed: true },
            jsonData: {
                Records: [{
                    Context: {
                        transaction_id: quoteDetails?.result?.Records[0]?.context?.transaction_id,
                        message_id: generateIds?.message_id,
                    },
                    Message: {
                        Id: quoteDetails?.result?.Records[0]?.message?.order?.Id,
                        OwnerType: 'LogisticsOrder',
                        PaidAmount: quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup[0]?.price?.value,
                        PaymentRemarks: 'LogisticsOrder',
                        PaymentMethodId: selected, // Number(sessionStorage.getItem('paymentmethod')),
                        PaymentGatewayId: paymentGateway[0]?.Id || 0,
                    },
                }

                ],
            }
        }))
        await dispatch(orders.resetAction({ actionType: 'create' }))
        await setIsPaymentAdded(true);


    }
    // Step 4: Confirm Logistics Order
    useEffect(() => {
        if (isPaymentAdded) {
            const isMediaFile = quoteDetails?.result?.Records[0]?.message?.order?.LinkedItems[0]?.value?.value >= 50000;
            const itemValues = quoteDetails?.result?.Records[0]?.message?.order?.items?.map((item: any) => {
                const data = {
                    id: item?.id,
                    fulfillment_id: item?.fulfillment_id,
                    category_id: item?.category_id,
                    descriptor: {
                        code: item?.descriptor?.code
                    },
                    time: {
                        label: null,
                        duration: null,
                        timestamp: item?.time?.timestamp
                    }
                };
                return data;
            });

            const breakupValues = quoteDetails?.result?.Records[0]?.message?.order?.quote?.breakup?.map((item: any) => {
                const data = {
                    "@ondc/org/item_id": item?.['@ondc/org/item_id'],
                    "@ondc/org/title_type": item?.['@ondc/org/title_type'],
                    "price": {
                        "currency": item?.price?.currency,
                        "value": item?.price?.value
                    }
                };
                return data;
            });
            const fulfillmentValues = quoteDetails?.result?.Records[0]?.message?.order?.fulfillments?.map((item: any) => {
                const data = {
                    "id": item?.id,
                    "type": item?.type,
                    "@ondc/org/awb_no": null,
                    "start": {
                        "person": {
                            "name": ''
                        },
                        "location": {
                            "gps": item?.start?.location?.gps,
                            "address": {
                                "name": item?.start?.location?.address?.name,
                                "building": item?.start?.location?.address?.building,
                                "locality": item?.start?.location?.address?.locality,
                                "city": item?.start?.location?.address?.city,
                                "state": item?.start?.location?.address?.state,
                                "country": item?.start?.location?.address?.country,
                                "area_code": item?.start?.location?.address?.area_code
                            }
                        },
                        "contact": {
                            "phone": item?.start?.contact?.phone,
                            "email": item?.start?.contact?.email
                        },
                        "instructions": {
                            "code": null,
                            "short_desc": null,
                            "long_desc": null,
                            "additional_desc": {
                                "content_type": null,
                                "url": null
                            },
                            "images": null

                        },
                        "time": {
                            "label": null,
                            "duration": null,
                            "timestamp": null
                        }
                    },
                    "end": {
                        "person": {
                            "name": ''
                        },
                        "location": {
                            "gps": item?.end?.location?.gps,
                            "address": {
                                "name": item?.end?.location?.address?.name,
                                "building": item?.end?.location?.address?.building,
                                "locality": item?.end?.location?.address?.locality,
                                "city": item?.end?.location?.address?.city,
                                "state": item?.end?.location?.address?.state,
                                "country": item?.end?.location?.address?.country,
                                "area_code": item?.end?.location?.address?.area_code
                            }
                        },
                        "contact": {
                            "phone": item?.end?.contact?.phone || '',
                            "email": item?.end?.contact?.email || ''
                        },
                        "instructions": {
                            "code": null,
                            "short_desc": null,
                            "long_desc": null,
                            "additional_desc": {
                                "content_type": null,
                                "url": null
                            },
                            "images": null
                        },
                        "time": {
                            "label": null,
                            "duration": null,
                            "timestamp": null
                        }
                    },
                    "agent": {},
                    "vehicle": {
                        "vehicleCategoryId": item?.vehicle?.vehicleCategoryId,
                        "vehicleId": item?.vehicle?.vehicleId,
                        "vehicleName": item?.vehicle?.vehicleName,
                        "VehicleBodyTypeId": item?.vehicle?.VehicleBodyTypeId,
                        "weight": item?.vehicle?.weight,
                        "loading_capacity": item?.vehicle?.loading_capacity,
                        "registration": item?.vehicle?.registration,
                        "TripVehicleBasePrice": item?.vehicle?.TripVehicleBasePrice,
                    },
                    "EWayBill": {
                        "MediaFiles": isMediaFile ? mediaFiles : [],
                        "Templates": []
                    },
                    "@ondc/org/ewaybillno": null,
                    "@ondc/org/ebnexpirydate": null,
                    "tags": [
                        {
                            "code": null,
                            "list": [
                                {
                                    "code": null,
                                    "value": null
                                }
                            ]
                        }
                    ]
                };
                return data;
            });
            const linkedItemValues = quoteDetails?.result?.Records[0]?.message?.order?.LinkedItems?.map((item: any) => {
                let category = _.find(productTypesListItems?.result?.items, ['Id', item?.CategoryId]);
                let product = _.find(ProductLists?.result?.items, ['Id', item?.LogisticsProductId]);
                const data = {
                    "CategoryName": category?.Name,
                    "CategoryId": item?.CategoryId,
                    "LogisticsProductId": item?.LogisticsProductId,
                    "LogisticsVariantId": item?.LogisticsVariantId,
                    "descriptor": {
                        "name": product?.Name
                    },
                    "quantity": {
                        "count": item?.quantity?.count,
                        "measure": {
                            "unit": item?.quantity?.measure?.unit,
                            "value": item?.quantity?.measure?.value
                        }
                    },

                    "price": {
                        "currency": item?.value?.currency,
                        "value": item?.value?.value
                    },
                    "dangerous_goods": item?.dangerous_goods
                };
                return data;
            });
            const tagValues = quoteDetails?.result?.Records[0]?.message?.order?.tags?.map((item: any) => {
                const data = {
                    code: item?.code,
                    list: item?.list?.map((listItem: any) => {
                        const data = {
                            "code": listItem?.code,
                            "value": listItem?.value
                        }
                        return data;

                    })
                };
                return data;
            });
            const orderData = {
                context: {
                    transaction_id: quoteDetails?.result?.Records[0]?.context?.transaction_id,
                    message_id: generateIds?.fulfillment_id,
                },
                message: {
                    order: {
                        created_at: moment.utc(),
                        updated_at: moment.utc(),
                        id: generateIds.order_id,
                        state: null,
                        IsCargoOrder: true,
                        provider: {
                            id: quoteDetails?.result?.Records[0]?.message?.order?.provider?.id,
                            locations: quoteDetails?.result?.Records[0]?.message?.order?.provider?.locations
                        },
                        items: itemValues,
                        quote: {
                            price: {
                                currency: quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.currency,
                                value: quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.value,
                            },
                            TotalDistance: quoteDetails?.result?.Records[0]?.message?.order?.quote?.TotalDistance,
                            breakup: breakupValues
                        },
                        fulfillments: fulfillmentValues,
                        "billing": {
                            "name": fulfillmentValues[0]?.start?.person?.name || '',
                            "address": {
                                "name": fulfillmentValues[0]?.start?.location?.address?.name || '',
                                "building": fulfillmentValues[0]?.start?.location?.address?.building || '',
                                "locality": fulfillmentValues[0]?.start?.location?.address?.locality || '',
                                "city": fulfillmentValues[0]?.start?.location?.address?.city || '',
                                "state": fulfillmentValues[0]?.start?.location?.address?.state || '',
                                "country": fulfillmentValues[0]?.start?.location?.address?.country || '',
                                "area_code": fulfillmentValues[0]?.start?.location?.address?.area_code || '',
                            },
                            "tax_number": '',
                            "phone": fulfillmentValues[0]?.start?.contact?.phone || '',
                            "email": fulfillmentValues[0]?.start?.contact?.email || '',

                        },
                        "payment": {
                            "@ondc/org/collection_amount": null,
                            "collected_by": null,
                            "type": null,
                            "@ondc/org/settlement_details": [
                                {
                                    "settlement_counterparty": null,
                                    "settlement_type": null,
                                    "upi_address": null,
                                    "settlement_bank_account_no": null,
                                    "settlement_ifsc_code": null
                                }
                            ]
                        },
                        "@ondc/org/linked_order": {
                            "items": linkedItemValues,
                            "provider": {
                                "descriptor": {
                                    "name": null
                                },
                                "address": {
                                    "name": organizationUnitLists?.result?.items[0]?.Name,
                                    "building": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Address1,
                                    "locality": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Address2,
                                    "city": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.City,
                                    "state": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.StateProvince?.Name,
                                    "country": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.Country?.Name,
                                    "area_code": organizationUnitLists?.result?.items[0]?.PrimaryAddress?.ZipPostalCode
                                }
                            },
                            "order":
                            {
                                "id": null,
                                "weight": {
                                    "unit": "mm",
                                    "value": 600
                                },
                                "dimensions": {
                                    "length": {
                                        "unit": "mm",
                                        "value": 50
                                    },
                                    "breadth": {
                                        "unit": "mm",
                                        "value": 60
                                    },
                                    "height": {
                                        "unit": "mm",
                                        "value": 30
                                    }
                                }
                            }

                        },
                        "tags": tagValues,

                    }
                }
            }
            dispatch(orders.create({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/confirm-logistics-order`,
                entity: 'orderCreate', options: { notifyOnSuccess: false, notifyOnFailed: true },
                jsonData: {
                    Records: [orderData]
                }
            })).then(() => {
                setIsLoading(false)
                setEnableConfirm(false)
                setIsOrderPlaced(true);
                setIsOpenPayment(false)
            })
        }
    }, [isPaymentAdded])

    // Start- ccAvenue function
    const encrypt1 = (plainText: string, workingKey: string): string => {
        // Create an MD5 hash of the workingKey
        const key = CryptoJS.MD5(workingKey).toString(CryptoJS.enc.Hex);

        // Initialization vector (IV)
        const iv = CryptoJS.enc.Hex.parse('000102030405060708090a0b0c0d0e0f');

        // Encrypt the plainText
        const encrypted = CryptoJS.AES.encrypt(plainText, CryptoJS.enc.Hex.parse(key), {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        // Return the encrypted text in hex format
        return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
    };
    const handeCCAvenuePayment = (orderDetails: any) => {
        const workingKey =
            razorpaySettings.CCAvenue?.WorkingKey; //Put in the 32-Bit key shared by CCAvenues.
        const accessCode =
            razorpaySettings.CCAvenue?.AccessCode;
        const merchantId =
            razorpaySettings.CCAvenue?.MerchantId;

        const companyName = localStorage.getItem("CompanyName");
        const channelId = storePersist.get("accessTokenMetadata").current?.TokenMetadata?.SalesChannelId;
        const tenant = companyName; //getBusinessCompanyName();


        // const guestTokenData = {
        // 	Channel: channel.SalesChannelName, //SalesChannelName(),
        // 	Requester: `https://${tenant}.csp.digiit.${process.env.REACT_APP_API_URL}/`,
        // 	StoreId: storeId,
        // 	SalesChannelId: ChannelId,
        // };
        // const accessTokenData = {
        // 	PhoneNumber: userInfo[0]?.PhoneNumber,
        // 	TenantName: tenant,
        // 	SalesChannelId: ChannelId,
        // };
        const ccAvenueData = {
            merchant_id: merchantId,
            order_id: orderDetails?.order?.id,
            currency: 'INR',
            amount: Number(orderDetails?.order?.quote?.price?.value), //Total Price,

            //   ENABLE WHILE TESTING LOCALLY. NEEDS TO BE RUN ALONG WITH PAYMENTS REPO.
            //   redirect_url: `http://localhost:3004/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${billingAddress?.PhoneNumber}/ccavResponseHandler`,
            //   cancel_url: `http://localhost:3004/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${billingAddress?.PhoneNumber}/ccavResponseHandler`,

            // ENABLE FOR PRODUCTION
            redirect_url: `https://payments.digiit.${process.env.REACT_APP_API_URL}/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${userProfileData?.PhoneNumber}/ccavResponseHandler`,
            cancel_url: `https://payments.digiit.${process.env.REACT_APP_API_URL}/${MODE}/${tenant}/${tenantId}/${storeId}/${channelId}/${userProfileData?.PhoneNumber}/ccavResponseHandler`,

            language: 'EN',
            billing_name: orderDetails?.order?.billing?.name,
            billing_address: orderDetails?.order?.billing?.address?.name,
            billing_city: orderDetails?.order?.billing?.address?.city,
            billing_state: orderDetails?.order?.billing?.address?.state,
            billing_zip: orderDetails?.order?.billing?.address?.area_code,
            billing_country: orderDetails?.order?.billing?.address?.country,
            billing_tel: userProfileData?.PhoneNumber,
            billing_email: userProfileData?.Email,
            delivery_name: orderDetails?.order?.fulfillments[0]?.end?.person?.name,
            delivery_address: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.name,
            delivery_city: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.city,
            delivery_state: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.state,
            delivery_zip: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.area_code,
            delivery_country: orderDetails?.order?.fulfillments[0]?.end?.location?.address?.country,
            merchant_param1: tenant, //getOrganizationName(),
            merchant_param2: tenantId,
            merchant_param3: `${window.location.hostname}`,
            merchant_param4: 'customer/cargo/order-details',
            merchant_param5: '',
            integration_type: 'iframe_normal',
            // promo_code:'PROMO8513',
            customer_identifier: userProfileData?.Email,
        };

        const body = queryString.stringify(ccAvenueData);

        const encRequest1 = encrypt1(body, workingKey);
        // let URL = `https://test.ccavenue.com/transaction/transaction.do?command=initiateTransaction&merchant_id=${ccAvenueData.merchant_id}6&encRequest=${encRequest1}&access_code=${accessCode}`;
        let URL = `https://${MODE}.ccavenue.com/transaction/transaction.do?command=initiateTransaction&merchant_id=${ccAvenueData.merchant_id}6&encRequest=${encRequest1}&access_code=${accessCode}`;


        window.location.href = URL;
        // router.push(URL);
        dispatch(cargoLeads.resetAction({ actionType: 'create' }))
    }
    // End - ccAvenue function
    useEffect(() => {
        setRazorpaySettings(paymentMethodQuery?.result?.items?.RazorPayConfiguration);

    }, [paymentMethodQuery]);

    useEffect(() => {
        if (paymentMode) {
            if (paymentMode.name == 'Cash' || paymentMode.name == 'Wallet') {
                setPaymentGateway([]);
                setEnablePlaceOrder(true)
            } else if (paymentMode && razorpaySettings) {
                const gateways: any = []
                if (razorpaySettings?.RazorPay?.IsActive) {
                    gateways.push({ Id: 10, title: 'Razorpay', detail: 'Razorpay' })
                }
                if (razorpaySettings?.CCAvenue?.IsActive) {
                    gateways.push({ Id: 20, title: 'CC Avenue', detail: 'CC Avenue' })
                }
                if (razorpaySettings?.PhonePe?.IsActive) {
                    gateways.push({ Id: 30, title: 'PhonePe', detail: 'PhonePe' })
                }
                setPaymentGateway(gateways);
                setEnablePlaceOrder(true)
            } else {
                setEnablePlaceOrder(false)
            }
        }
    }, [paymentMode])

    useEffect(() => {
        if (isOrderPlaced) {
            switch (selected) {
                case 10: //cash payment
                    navigate('/customer/cargo/order-details')
                    setOrderItem(undefined)
                    dispatch(cargoLeads.resetAction({ actionType: 'create' }))
                    break;
                case 20: //online
                    switch (paymentGateway[0]?.Id) {
                        case 10: //razorpay
                            // handeRazorpay()
                            break;
                        case 20: //ccavenue
                            handeCCAvenuePayment(orderDetails?.result?.items?.Records[0]?.message)
                            break;
                        case 30: //phonepe
                            break;
                        default:
                    }


                    break;
                case 30: //wallet
                    break;
            }

        }
    }, [isOrderPlaced])

    useEffect(() => {
        generateIdValue()
        dispatch(vehicles.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/vehicle-registations/list`, entity: 'vehicles', jsonData: {

            }
        })).then(() => {
            dispatch(vehicleCategories.list({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/vehicle-categories/list`, entity: 'vehicles', jsonData: {}
            }));
        }).then(() => {
            dispatch(categories.list({
                url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/categories/list`,
                entity: 'categories',
                jsonData: {}
            }));
        }).then(() => {
            dispatch(shippingTypes.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/shipping-types/list`, entity: 'shippingTypes', jsonData: {} }))
        }).then(() => {
            dispatch(productTypes.list({ url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/product-types/list`, entity: 'productTypes', jsonData: {} }))
        })
    }, [])

    return (
        <div className="flex flex-col items-center w-full px-4  overflow-auto min-h-screen bg-gray-50">
            <div className="w-full  bg-white pb-10">
                <div className="border-b px-6 py-4">
                    <h2 className="text-2xl font-semibold text-center text-gray-800">Cargo Booking</h2>
                </div>

                <div className="flex justify-center px-4 md:px-8 py-8">
                    <div className="w-full md:w-3/4 space-y-6">

                        {/* Estimate Details Card */}
                        <AddressBookComponent
                            selectedToAddressBookId={selectedToAddressBookId}
                            selectedToAddressBook={selectedToAddressBook}
                            setSelectedToAddressBookId={setSelectedToAddressBookId}
                            setSelectedToAddressBook={setSelectedToAddressBook}
                            selectedFromAddressBookId={selectedFromAddressBookId}
                            selectedFromAddressBook={selectedFromAddressBook}
                            setSelectedFromAddressBookId={setSelectedFromAddressBookId}
                            setSelectedFromAddressBook={setSelectedFromAddressBook}
                            addressbookId={addressbookId}
                            addressBook={addressBook}
                        />

                        {/* Vehicle Cards Grid */}
                        <VehicleCard
                            isButtonLoading={isLoading}
                            loadCapacity={vehicleCategoryData?.result?.items}
                            vehicleData={vehicleData?.result?.items}
                            handleEstimate={handleEstimate}
                            productTypeCargo={productTypeCargo}
                            selectedEstimateItem={selectedEstimateItem}
                            handleInnerFormChange={handleChange}
                        />

                        {/* Order Booking Popup */}
                        {orderItem && (
                            <NewEstimatePopup
                                handleSavePackageItem={handleSavePackageItem}
                                handleOrderBooking={handleOrderBooking}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>


    );
};

export default AdvanceCargoBookingsWeb;


